import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlertComponent } from "ngx-bootstrap";

Injectable()
export class AlertsHolder {

    timeout: number;
    alerts: any[];

    constructor(private translate: TranslateService) {
        this.alerts = [];
        this.timeout = 3000;
    }

    show(msg: string, type: string, timeout?: number) {
        this.translate.get(msg).subscribe(message => {
            this.alerts.push({type: type, timeout : timeout?  timeout : this.timeout, msg : message})
        })
    }

    removeAlert(dismissedAlert: AlertComponent): void {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }
}


// WEBPACK FOOTER //
// ./src/app/models/AlertsHolder.ts